function Section({ tab, setTab, textContent }) {
  const services = [
    {
      title: "Customer Service",
      img: "images/outsourcing/0.webp",
      description:
        "Providing exceptional customer support representatives who are trained to handle inquiries, resolve issues, and deliver a positive customer experience.",
      responsibilities: [
        "Responding to customer inquiries via phone, email, and chat.",
        "Resolving customer issues and complaints promptly.",
        "Providing product and service information to customers.",
        "Maintaining accurate records of customer interactions and transactions.",
        "Escalating complex issues to higher-level support when necessary.",
      ],
    },
    {
      title: "Tech Support",
      img: "images/outsourcing/1.webp",
      description:
        "Supplying skilled tech support professionals who offer technical assistance and troubleshooting for your products and services, ensuring seamless operations.",
      responsibilities: [
        "Diagnosing and resolving technical issues for customers and clients.",
        "Providing step-by-step guidance for software and hardware problems.",
        "Conducting remote troubleshooting and diagnostics.",
        "Documenting issues and solutions for future reference.",
        "Collaborating with other technical teams to resolve complex issues.",
      ],
      reverse: true,
    },
    {
      title: "Appointment Setting",
      img: "images/outsourcing/2.webp",
      description:
        "Offering appointment setters to efficiently manage schedules, book meetings, and handle calendar coordination.",
      responsibilities: [
        "Making outbound calls to schedule appointments.",
        "Coordinating appointment details.",
        "Maintaining calendars.",
        "Sending reminders and follow-ups.",
        "Handling rescheduling and cancellations.",
      ],
    },
    {
      title: "Retentions",
      img: "images/outsourcing/3.webp",
      description:
        "Ensuring customer retention through specialists who focus on keeping your customers engaged and loyal.",
      responsibilities: [
        "Identifying at-risk customers.",
        "Conducting satisfaction surveys.",
        "Addressing concerns to prevent churn.",
        "Offering incentives and loyalty programs.",
        "Analyzing retention data and insights.",
      ],
      reverse: true,
    },
    {
      title: "Sales",
      img: "images/outsourcing/4.webp",
      description:
        "Delivering high-performing sales teams trained to boost revenue by identifying opportunities, closing deals, and nurturing leads.",
      responsibilities: [
        "Identifying and qualifying leads.",
        "Conducting presentations and demos.",
        "Negotiating and closing deals.",
        "Maintaining client relationships.",
        "Meeting and exceeding sales targets.",
      ],
    },
    {
      title: "Virtual Assistants",
      img: "images/outsourcing/5.webp",
      description:
        "Providing versatile virtual assistants for administrative tasks, managing communications, and supporting your team remotely.",
      responsibilities: [
        "Managing communications.",
        "Scheduling appointments.",
        "Administrative tasks and document handling.",
        "Research and reports.",
        "General team support.",
      ],
      reverse: true,
    },
    {
      title: "Web Designers",
      img: "images/outsourcing/6.webp",
      description:
        "Supplying creative web designers to develop visually appealing and user-friendly websites.",
      responsibilities: [
        "Designing layouts and features.",
        "Creating graphics and UI.",
        "Ensuring performance optimization.",
        "Understanding client requirements.",
        "Testing and troubleshooting.",
      ],
    },
    {
      title: "Trainers",
      img: "images/outsourcing/7.webp",
      description:
        "Offering experienced trainers to develop and deliver training programs.",
      responsibilities: [
        "Developing training materials.",
        "Conducting workshops.",
        "Assessing effectiveness.",
        "Coaching trainees.",
        "Keeping up with industry trends.",
      ],
      reverse: true,
    },
    {
      title: "Supervisors and Operations Managers",
      img: "images/outsourcing/8.webp",
      description:
        "Providing supervisors and operations managers who oversee operations, ensure compliance, and drive efficiency.",
      responsibilities: [
        "Managing and supervising teams.",
        "Optimizing processes.",
        "Monitoring performance metrics.",
        "Employee guidance and support.",
        "Ensuring compliance with policies.",
      ],
    },
    {
      title: "Workforce Reporting",
      img: "images/outsourcing/9.webp",
      description:
        "Delivering accurate workforce analytics and reporting services.",
      responsibilities: [
        "Collecting and analyzing workforce data.",
        "Generating performance reports.",
        "Providing insights and recommendations.",
        "Supporting HR and management decisions.",
        "Ensuring data accuracy and confidentiality.",
      ],
      extra: "And More...",
      reverse: true,
    },
  ];

  return (
    <section
      className={`tab-content ${tab === 2 ? "active" : ""}`}
      id="tab-outsourcing"
    >
      <div className="section-content">
        <div className="section-text">
          <h2>{textContent?.outsourcingSolutions?.title}</h2>

          {textContent?.outsourcingSolutions?.services?.map((s, i) => (
            <div key={i} className="service-item">
              {s.reverse ? null : (
                <img src={`images/outsourcing/${i}.webp`} alt={s.title} className="outsourcing-img" />
              )}

              <div>
                <h3>{s.title}</h3>
                <p>
                  <strong>{textContent?.outsourcingSolutions?.text0}</strong> {s.description}
                </p>

                <p>
                  <strong>{textContent?.outsourcingSolutions?.text1}</strong>
                </p>
                <ul>
                  {s.responsibilities.map((r, index) => (
                    <li key={index}>{r}</li>
                  ))}
                </ul>

                {s.extra && <h3>{s.extra}</h3>}
              </div>

              {s.reverse ? (
                <img src={`images/outsourcing/${i}.webp`} alt={s.title} className="outsourcing-img" />
              ) : null}
            </div>
          ))}

          <button className="cta-button" onClick={() => setTab(3)}>
            {textContent?.outsourcingSolutions?.cta}
          </button>
        </div>
      </div>
    </section>
  );
}

export default Section;
